import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DailyrentActionButtonsContainer } from 'shared/containers/AsideContacts/DailyrentActionButtonsContainer';
import { ElectronicTradingContactButtonContainer } from 'shared/containers/ElectronicTradingContactButtonContainer';
import { useIsElectronicTradingOffer } from 'shared/hooks/useIsElectronicTradingOffer';
import { isNewbuildingPageSelector, selectIsOfferPublished } from 'shared/selectors';
import { selectShouldRenderContacts } from 'shared/selectors/contacts/selectShouldRenderContacts';
import { selectorEntryToShowEnabled } from 'shared/selectors/contacts/selectorEntryToShowEnabled';
import { isRentDailySelector } from 'shared/selectors/isRentDaily';
import { getUserChatOnlineStatus } from 'shared/services/chats/getUserChatOnlineStatus';

import { NewbuildingPageAsideContactsContainer } from './NewbuildingPageAsideContactsContainer';
import { PhonesContainer } from './PhonesContainer';
import { SendMessageButtonContainer } from './SendMessageButton';
import { EarlyAccessCounterBannerContainer } from '../EarlyAccessCounterBannerContainer/EarlyAccessCounterBannerContainer';
import { OnlineStatusContainer } from '../OnlineStatusContainer';

export const AsideContactsContainer = () => {
  const shouldRenderContactButtons = useSelector(selectShouldRenderContacts);
  const isPublished = useSelector(selectIsOfferPublished);
  const entryToShowEnabled = useSelector(selectorEntryToShowEnabled);
  const isNewbuildingPage = useSelector(isNewbuildingPageSelector);
  const isElectronicTradingOffer = useIsElectronicTradingOffer();

  const isDailyrent = useSelector(isRentDailySelector);

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(getUserChatOnlineStatus());
  }, []);

  if (!isPublished || entryToShowEnabled) {
    return null;
  }

  if (isDailyrent) {
    return <DailyrentActionButtonsContainer />;
  }

  if (isNewbuildingPage) {
    return <NewbuildingPageAsideContactsContainer />;
  }

  return (
    <>
      <EarlyAccessCounterBannerContainer />
      {!isElectronicTradingOffer && shouldRenderContactButtons && <PhonesContainer />}
      {isElectronicTradingOffer && (
        <ElectronicTradingContactButtonContainer buttonFullWidth dataTestId="electronic-trading-button-aside" />
      )}
      {shouldRenderContactButtons && <SendMessageButtonContainer />}
      <OnlineStatusContainer />
    </>
  );
};
